import { linkLauncher, showSideTeamStatusBar, tabHighlight } from './helpers';
import { createWebappRoute, getCurrentRouteParams } from '../helpers';
import userSession from '@webapp-next/lib/user-session';
import EVENTS from '@/modules/integrations/events';
import checkFF from '@/lib/feature-flag';

export default [
  createWebappRoute({
    path: '/enterprise/:subModule(.*)*',
    name: 'enterprise-module-submodules',
    component() {
      if (userSession().IsSubscriptionPaused) {
        $dt.showPausedBusinessAccountModal();
        return;
      }

      const subModule = getCurrentRouteParams()?.subModule?.[0] || '';

      if (!!subModule.match(/^modal_/)) {
        $dt.vwApplicationModal.runApp(subModule);
        return;
      }

      tabHighlight('enterprise');
      showSideTeamStatusBar(false);

      if (!subModule) {
        return;
      }

      if (subModule === 'enterprise') {
        getRouter().push('/enterprise');
        return;
      }

      const isVueRouterActive = checkFF('core-0-vue-router');

      if (subModule === 'bulk-import-update') {
        if (!isVueRouterActive) {
          VueEventBus.$emit(EVENTS.INTEGRATIONS_BULK_IMPORT_UPDATE_OPEN);
        } else {
          VueEventBus.$emit(
            EVENTS.INTEGRATIONS_BULK_IMPORT_UPDATE_OPEN_VUE_ROUTER
          );
          return;
        }
      }

      // open submodule based on the clicked link
      const $link = $(`a#${subModule}`);

      linkLauncher(
        $link.attr('data-url'),
        $link.attr('data-name'),
        $link.attr('href')
      );

      $('#container-enterprise').hide();
    },
  }),

  // 'enterprise_importer/*orm': 'enterprise_importer',
  createWebappRoute({
    path: '/enterprise_importer/*orm',
    name: 'enterprise-importer-module',
    component() {
      console.log('ROUTER, enterprise');
      const { orm } = getCurrentRouteParams();

      tabHighlight('enterprise');
      showSideTeamStatusBar(false);

      if (orm) {
        const strTitle = 'Import Data';
        linkLauncher(
          '/exec/import/import_data?orm=' + orm,
          strTitle,
          'enterprise_importer/' + orm
        );
        $('#container-enterprise').hide();
      }

      return {};
    },
  }),

  // 'enterprise_importer_modal/*orm': 'enterprise_importer_modal',
  createWebappRoute({
    path: '/enterprise_importer_modal/*orm',
    name: 'enterprise-importer-modal-module',
    component() {
      console.log('ROUTER, enterprise');
      const { orm } = getCurrentRouteParams();

      if (orm) {
        $dt.vwApplicationModal.runImporterByOrm(orm);
      }

      return {};
    },
  }),

  // 'enterprise_importer_modal_fetchdata/:orm/:companyid/*hiddencolumn': 'enterprise_importer_modal_fetchdata',
  createWebappRoute({
    path: '/enterprise_importer_modal_fetchdata/:orm/:companyid/*hiddencolumn',
    name: 'enterprise-module-importer-modal-fetchdata',
    component() {
      console.log(
        'ROUTER, enterprise, enterprise_importer_modal_fetchdata/:orm/:companyid/*hiddencolumn'
      );

      const { orm, companyid, hiddencolumn } = getCurrentRouteParams();

      if (orm) {
        $dt.vwApplicationModal.runImporterInFetchDataModeWithHiddenColumn(
          orm,
          companyid,
          hiddencolumn
        );
      }

      return {};
    },
  }),

  // 'enterprise_team_edit/*id': 'enterprise_team',

  createWebappRoute({
    path: '/enterprise_team_edit/*id',
    name: 'enterprise-module-team-edit',
    component() {
      console.log('ROUTER, enterprise, enterprise_team_edit');

      tabHighlight('team');
      let strTitle = 'Edit';
      const objEmp = $dtteam.clcEmployee.get(id); // TODO: replace this with new people module

      if (objEmp) {
        strTitle += ' : ' + objEmp.get('DisplayName');
      }

      linkLauncher(
        '/exec/administration/workforce/employee_list?-edit=' + id,
        strTitle,
        'enterprise_team_edit/' + id
      );

      showSideTeamStatusBar(false);
      $('#container-team').hide();

      return {};
    },
  }),

  // 'enterprise_team_add': 'enterprise_team_add',
  createWebappRoute({
    path: '/enterprise_team_add',
    name: 'enterprise-module-team-add',
    component() {
      console.log('ROUTER, enterprise, enterprise_team_add');

      tabHighlight('team');
      linkLauncher(
        '/exec/administration/workforce/employee_list?-create',
        'Add Person',
        'enterprise_team_add'
      );
      showSideTeamStatusBar(false);
      $('#container-team').hide();

      return {};
    },
  }),

  // 'enterprise_manage_customfields_modal': 'enterprise_manage_customfields_modal',
  createWebappRoute({
    path: '/enterprise_manage_customfields_modal',
    name: 'enterprise-module-enterprise_manage_customfields_modal',
    component() {
      console.log('ROUTER, enterprise, enterprise_manage_customfields_modal');

      if ($dtw.vwModalSystemWideConfig) {
        $dtw.vwModalSystemWideConfig.hideMe();
      }

      $dt.vwApplicationModal.linkAppRunner(
        '/exec/devapp/fields',
        'Custom Field',
        'enterprise_manage_customfields_modal'
      );

      return {};
    },
  }),

  // 'enterprise_manage_stress_profiles_modal': 'enterprise_manage_stress_profiles_modal',
  createWebappRoute({
    path: '/enterprise_manage_stress_profiles_modal',
    name: 'enterprise-module-enterprise_manage_stress_profiles_modal',
    component() {
      console.log(
        'ROUTER, enterprise, enterprise_manage_stress_profiles_modal'
      );

      if ($dtw.vwModalSystemWideConfig) {
        $dtw.vwModalSystemWideConfig.hideMe();
      }

      $dt.vwApplicationModal.linkAppRunner(
        '/exec/administration/agreements/stress_profile',
        'Stress Profiles',
        'enterprise_manage_stress_profiles_modal'
      );

      return {};
    },
  }),

  // 'enterprise_manage_training_module_modal': 'enterprise_manage_training_module_modal',
  createWebappRoute({
    path: '/enterprise_manage_training_module_modal',
    name: 'enterprise-module-enterprise_manage_training_module_modal',
    component() {
      console.log(
        'ROUTER, enterprise, enterprise_manage_training_module_modal'
      );

      if ($dtw.vwModalSystemWideConfig) {
        $dtw.vwModalSystemWideConfig.hideMe();
      }

      $dt.vwApplicationModal.linkAppRunner(
        '/exec/hr/training/training_module',
        'Training Module',
        'enterprise_manage_training_module_modal'
      );

      return {};
    },
  }),

  // 'enterprise_manage_add_shift_template_modal': 'enterprise_manage_add_shift_template_modal',
  createWebappRoute({
    path: '/enterprise_manage_add_shift_template_modal',
    name: 'enterprise-module-enterprise_manage_add_shift_template_modal',
    component() {
      console.log(
        'ROUTER, enterprise, enterprise_manage_add_shift_template_modal'
      );

      if ($dtw.vwModalSystemWideConfig) {
        $dtw.vwModalSystemWideConfig.hideMe();
      }

      const shiftLabel = window?.__APP__?.DEFAULT_SHIFT_LABEL;
      const shiftLabelCapitalized =
        shiftLabel.charAt(0).toUpperCase() + shiftLabel.slice(1);

      $dt.vwApplicationModal.linkAppRunner(
        '/exec/administration/agreements/shift_template',
        `${shiftLabelCapitalized} Template`,
        'enterprise_manage_add_shift_template_modal'
      );

      return {};
    },
  }),

  // 'enterprise_manage_leave_rule': 'enterprise_manage_leave_rule',
  createWebappRoute({
    path: '/enterprise_manage_leave_rule',
    name: 'enterprise-module-enterprise_manage_leave_rule',
    component() {
      console.log('ROUTER, enterprise, enterprise_manage_leave_rule');

      if ($dtw.vwModalSystemWideConfig) {
        $dtw.vwModalSystemWideConfig.hideMe();
      }

      $dt.vwApplicationModal.linkAppRunner(
        '/exec/administration/agreements/leave_rules',
        'Leave Rules',
        'enterprise_manage_leave_rule'
      );

      return {};
    },
  }),

  // 'enterprise_manage_filters_modal': 'enterprise_manage_filters_modal',
  createWebappRoute({
    path: '/enterprise_manage_filters_modal',
    name: 'enterprise-module-enterprise_manage_filters_modal',
    component() {
      console.log('ROUTER, enterprise, enterprise_manage_filters_modal');

      if ($dtw.vwModalSystemWideConfig) {
        $dtw.vwModalSystemWideConfig.hideMe();
      }

      $dt.vwApplicationModal.linkAppRunner(
        '/exec/config/schedule_filters',
        'Schedule Sort Options',
        'enterprise_manage_filters_modal'
      );

      return {};
    },
  }),

  // 'enterprise_team_import': 'enterprise_team_import',
  createWebappRoute({
    path: '/enterprise_team_import',
    name: 'enterprise-module-enterprise_team_import',
    component() {
      console.log('ROUTER, enterprise, enterprise_team_import');

      tabHighlight('team');
      linkLauncher(
        '/exec/import/employee_import',
        'Advanced CSV Import',
        'enterprise_team_import'
      );

      showSideTeamStatusBar(false);
      $('#container-team').hide();

      return {};
    },
  }),

  // 'enterprise_sso_settings': 'enterprise_sso_settings',
  createWebappRoute({
    path: '/enterprise_sso_settings',
    name: 'enterprise-module-enterprise_sso_settings',
    component() {
      console.log('ROUTER, enterprise, enterprise_sso_settings');

      if ($dtw.vwModalSystemWideConfig) {
        $dtw.vwModalSystemWideConfig.hideMe();
      }

      $dt.vwApplicationModal.linkAppRunner(
        '/exec/config/sso-configuration',
        'Single Sign-On settings',
        'enterprise_sso_settings'
      );

      return {};
    },
  }),

  // 'enterprise_employment_term_import': 'enterprise_employment_term_import',
  createWebappRoute({
    path: '/enterprise_employment_term_import',
    name: 'enterprise-module-enterprise_employment_term_import',
    component() {
      console.log('ROUTER, enterprise, enterprise_employment_term_import');

      tabHighlight('team');
      linkLauncher(
        '/exec/import/employment_term_import',
        'Employment Term Import',
        'enterprise_employment_term_import'
      );

      showSideTeamStatusBar(false);
      $('#container-team').hide();

      return {};
    },
  }),
];
